import { ConstanteGlobal } from "../config/constanteGlobal";
import { ModeloProduto } from "../models/produto";
import { FiltroBasico } from "../models/basico";
import { Repositorio } from "./repositorio";
import { ModeloSopProduto } from "../models/sopProduto";

export class FiltroSopProduto extends FiltroBasico<ModeloSopProduto> {
  cod_product_family ?: string;
  
}

export class RepositorioSopProduto extends Repositorio<ModeloSopProduto> {
  constructor() {
    super(ConstanteGlobal.SOP_PRODUTO);
  }
}
